<template>
  <app-popup-page>
    <div class="w-full my-auto">
      <section class="mb-4">
        <img
          class="object-contain w-full max-w-md mx-auto"
          :src="page.bannerImage"
        />
      </section>
      <section class="mb-4">
        <div v-if="page.sottoTitolo" class=" prose" v-html="page.sottoTitolo" />
      </section>
      <section class="mb-4 prose">
        <div v-html="page.listTitle1" />
        <ul class="list--bpay">
          <li
            v-for="(line, i) in page.list1"
            :key="`list-1.${i}`"
            v-html="line.text"
          />
        </ul>
      </section>
      <section class="mb-4 prose">
        <div v-html="page.listTitle2" />
        <ul class="list--bpay">
          <li
            v-for="(line, i) in page.list2"
            :key="`list-2.${i}`"
            v-html="line.text"
          />
        </ul>
      </section>
    </div>
  </app-popup-page>
</template>

<script>
import { axios } from "@/plugins/axios";
export default {
  props: { navigate: { default: null } },
  async beforeRouteEnter(to, from, next) {
    let page;
    try {
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      next(vm => (vm.page = page.data));
    }
  }
};
</script>

<style scoped>
.list--bpay > li {
  /* list-style-image: url("/assets/Desktop/7_Tecnologia/IBL_Sito_ControCorrente_Icona_Bancomat_PopUp.png"); */
  @apply bg-no-repeat mb-6;
  background-image: url("/assets/Desktop/7_Tecnologia/IBL_Sito_ControCorrente_Icona_Bancomat_PopUp.png");
  background-size: 1.25rem 1.25rem;
}
.prose ul.list--bpay > li::before {
  content: none;
}
</style>

<route>
  {
    "name": "Info Bancomat Pay",
      "meta": {
   
  }
}
</route>
